/**
 * Animated open/close for product accordions (.product__accordion details).
 * Native <details> toggles instantly and doesn't animate reliably on repeat
 * clicks. This intercepts the summary click and drives the open/close with the
 * Web Animations API, so it animates smoothly every time.
 *
 * Uses event delegation on document, so it keeps working after Shopify
 * re-renders the product section (variant changes, theme editor, etc.).
 */
(function () {
  var DURATION = 320;
  var EASING = 'ease';
  var animating = new WeakMap(); // details -> Animation

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getContent(details) {
    return details.querySelector('.accordion__content');
  }

  function expand(details, content) {
    details.open = true; // must be open so content has height
    var end = content.offsetHeight;
    var anim = content.animate(
      [{ height: '0px', opacity: 0 }, { height: end + 'px', opacity: 1 }],
      { duration: DURATION, easing: EASING }
    );
    animating.set(details, anim);
    anim.onfinish = function () {
      content.style.height = '';
      animating.delete(details);
    };
    anim.oncancel = function () { animating.delete(details); };
  }

  function collapse(details, content) {
    var start = content.offsetHeight;
    var anim = content.animate(
      [{ height: start + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: DURATION, easing: EASING }
    );
    animating.set(details, anim);
    anim.onfinish = function () {
      details.open = false; // remove open only after the close animation
      content.style.height = '';
      animating.delete(details);
    };
    anim.oncancel = function () { animating.delete(details); };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.product__accordion details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    var content = getContent(details);
    if (!content) return; // let native behavior handle it

    if (prefersReducedMotion()) return; // native instant toggle

    // We control the toggle ourselves.
    event.preventDefault();

    // Cancel any in-flight animation so rapid clicks reverse smoothly.
    var current = animating.get(details);
    if (current) current.cancel();

    if (details.open) {
      collapse(details, content);
    } else {
      expand(details, content);
    }
  });
})();
